<template>
    <!-- TODO : Problème de mise à jour du tableau après la sauvegarde -->
    <b-container :style="generateVariantStyle(Variant)" class="w-100 h-100 m-0 p-0 d-flex flex-column" fluid>
        <b-row class="w-100 h-100 m-0 overflow-auto">
            <b-col class="m-0 p-1">
                <b-card :id="$id('OperatParameter')" class="border-0 h-100"
                        header-class="pb-0">
                    <template #header>
                        <b-row class="px-3">
                            <b-col>
                                <h4 class="font-weight-bold">
                                    {{ $t('OperatParameter') }}
                                </h4>
                            </b-col>
                        </b-row>
                        <b-row class="px-3">
                            <b-col>
                                <h6 class="font-weight-normal">
                                    {{ $t("OperatParameterSubtitle") }}
                                </h6>
                            </b-col>
                        </b-row>
                    </template>
                    <b-card-body class="p-0 h-100">
                        <b-container class="m-0 p-0 h-100 w-100 border-0" fluid>
                            <splitpanes class="default-theme h-100">
                                <pane class="p-0 h-100 d-flex flex-column">
                                    <b-card bg-variant="white"
                                            class="border-0 w-100 h-100 d-flex flex-column headerHeight"
                                            footer-class="bg-white border border-bottom-0 border-left-0 border-right-0 py-2"
                                            header-class="bg-white border border-top-0 border-left-0 border-right-0
                                                        font-weight-semibold py-2">
                                        <template #header>
                                            <b-row>
                                                <b-col class="pt-2">
                                                    <h6>{{ $t("NodeList") }}</h6>
                                                </b-col>
                                                <b-col md="auto">
                                                    <div class="btn-circle"></div>
                                                </b-col>
                                            </b-row>
                                        </template>
                                        <b-card-body class="p-0 h-100 overflow-auto">
                                            <b-row class="p-0 m-0 w-100">
                                                <b-col class="m-0 p-0">
                                                    <GenericTable :EnablePagination="true" :EnableSelection="true"
                                                                  :Headers="tableHeaders" :Loading.sync="loading"
                                                                  :PerPage="5"
                                                                  :Rows="tableRows"
                                                                  :ShowColumnsSelector="true"
                                                                  :Variant="Variant">
                                                        <template #column(YearsRecovered)="row">
                                                            <template v-if="row.row['YearsRecovered'] != undefined
                                                                    && row.row['YearsRecovered'].length > 0">
                                                                <b-card
                                                                    v-if="row.row['YearsRecovered'].filter(a=> a.Error != null && a.Error != 'Récupération faite.').length > 0"
                                                                    bg-variant="transparent"
                                                                    body-class="bg-transparent m-0 p-0"
                                                                    class="pb-0 w-100"
                                                                    header-class="bg-transparent m-0 p-0 pt-1">
                                                                    <template #header>
                                                                        <b-row class="m-0 p-0"
                                                                               @click.stop="activeErrors[row.row['PersistentRef']]['error'] = !activeErrors[row.row['PersistentRef']]['error']">
                                                                            <b-col class="m-0 p-0" cols="auto">
                                                                                <b-icon icon="exclamation-triangle-fill"
                                                                                        variant="danger"/>
                                                                            </b-col>
                                                                            <b-col :class="`text-${Variant}`"
                                                                                   class="m-0 ml-2 p-0">
                                                                                <u>{{
                                                                                        row.row['YearsRecovered'].filter(a => a.Error != null && a.Error != 'Récupération faite.').length
                                                                                    }}
                                                                                    {{
                                                                                        $t('DataInErrors')[row.row['YearsRecovered'].filter(a => a.Error != null && a.Error != 'Récupération faite.').length == 1 ? 0 : 1]
                                                                                    }}</u>
                                                                            </b-col>
                                                                            <b-col cols="auto">
                                                                                <b-button
                                                                                    v-if="activeErrors[row.row['PersistentRef']]['error']"
                                                                                    class="bg-transparent border-0 text-danger px-0"
                                                                                    size="sm"
                                                                                    @click.stop="activeErrors[row.row['PersistentRef']]['error'] = !activeErrors[row.row['PersistentRef']]['error']">
                                                                                    <!-- Close -> "Fermer" -->
                                                                                    <b-icon v-b-tooltip.hover
                                                                                            :title="$t('Close')"
                                                                                            icon="chevron-up"
                                                                                            role="button"
                                                                                            scale="1.5"/>
                                                                                </b-button>
                                                                                <b-button v-else
                                                                                          class="bg-transparent border-0 text-danger px-0"
                                                                                          size="sm"
                                                                                          @click.stop="activeErrors[row.row['PersistentRef']]['error'] = !activeErrors[row.row['PersistentRef']]['error']">
                                                                                    <!-- Open -> "Ouvrir" -->
                                                                                    <b-icon v-b-tooltip.hover
                                                                                            :title="$t('Open')"
                                                                                            icon="chevron-down"
                                                                                            role="button"
                                                                                            scale="1.5"/>
                                                                                </b-button>
                                                                            </b-col>
                                                                        </b-row>
                                                                    </template>
                                                                    <b-card-body
                                                                        v-if="activeErrors[row.row['PersistentRef']]['error']"
                                                                        :class="`border-${Variant}`"
                                                                        class="mx-2 px-1 py-0 border border-right-0 border-top-0 border-bottom-0">
                                                                        <div>
                                                                            <div
                                                                                v-for="(error) in row.row['YearsRecovered'].filter(a => a.Error != null && a.Error != 'Récupération faite.')">
                                                                                <b-icon v-b-tooltip.hover
                                                                                        :title="error.Error"
                                                                                        icon="exclamation-triangle-fill"
                                                                                        variant="danger"/>
                                                                                <span class="font-weight-semibold ml-2">{{
                                                                                        error.Year == 'Ref' ? $t(error.Year) : error.Year
                                                                                    }}
                                                                                        | </span><small>{{
                                                                                    new Date(error.DateAsk).toLocaleDateString()
                                                                                }}</small>
                                                                            </div>
                                                                        </div>
                                                                    </b-card-body>
                                                                </b-card>
                                                                <b-card
                                                                    v-if="row.row['YearsRecovered'].filter(a=> a.Error == 'Récupération faite.').length > 0"
                                                                    bg-variant="transparent"
                                                                    body-class="bg-transparent m-0 p-0"
                                                                    class="pb-0 w-100"
                                                                    header-class="bg-transparent m-0 p-0 pt-1">
                                                                    <template #header>
                                                                        <b-row class="m-0 p-0"
                                                                               @click.stop="activeErrors[row.row['PersistentRef']]['ok'] = !activeErrors[row.row['PersistentRef']]['ok']">
                                                                            <b-col class="m-0 p-0" cols="auto">
                                                                                <b-icon icon="check2-circle"
                                                                                        variant="success"/>
                                                                            </b-col>
                                                                            <b-col class="text-success m-0 ml-2 p-0">
                                                                                <u>{{
                                                                                        row.row['YearsRecovered'].filter(a => a.Error == 'Récupération faite.').length
                                                                                    }}
                                                                                    {{
                                                                                        $t('DatasOK')[row.row['YearsRecovered'].filter(a => a.Error == 'Récupération faite.').length == 1 ? 0 : 1]
                                                                                    }}</u>
                                                                            </b-col>
                                                                            <b-col cols="auto">
                                                                                <b-button
                                                                                    v-if="activeErrors[row.row['PersistentRef']]['ok']"
                                                                                    class="bg-transparent border-0 text-success px-0"
                                                                                    size="sm"
                                                                                    @click.stop="activeErrors[row.row['PersistentRef']]['ok'] = !activeErrors[row.row['PersistentRef']]['ok']">
                                                                                    <!-- Close -> "Fermer" -->
                                                                                    <b-icon v-b-tooltip.hover
                                                                                            :title="$t('Close')"
                                                                                            icon="chevron-up"
                                                                                            role="button"
                                                                                            scale="1.5"/>
                                                                                </b-button>
                                                                                <b-button v-else
                                                                                          class="bg-transparent border-0 text-success px-0"
                                                                                          size="sm"
                                                                                          @click.stop="activeErrors[row.row['PersistentRef']]['ok'] = !activeErrors[row.row['PersistentRef']]['ok']">
                                                                                    <!-- Open -> "Ouvrir" -->
                                                                                    <b-icon v-b-tooltip.hover
                                                                                            :title="$t('Open')"
                                                                                            icon="chevron-down"
                                                                                            role="button"
                                                                                            scale="1.5"/>
                                                                                </b-button>
                                                                            </b-col>
                                                                        </b-row>
                                                                    </template>
                                                                    <b-card-body
                                                                        v-if="activeErrors[row.row['PersistentRef']]['ok']"
                                                                        class="mx-2 px-1 py-0 border border-success border-right-0 border-top-0 border-bottom-0">
                                                                        <div>
                                                                            <div
                                                                                v-for="(error) in row.row['YearsRecovered'].filter(a => a.Error == 'Récupération faite.')">
                                                                                <b-icon v-b-tooltip.hover
                                                                                        :title="error.Error"
                                                                                        icon="check2-circle"
                                                                                        variant="success"/>
                                                                                <span class="font-weight-semibold ml-2">{{
                                                                                        error.Year == 'Ref' ? $t(error.Year) : error.Year
                                                                                    }}
                                                                                        | </span><small>{{
                                                                                    new Date(error.DateAsk).toLocaleDateString()
                                                                                }}</small>
                                                                            </div>
                                                                        </div>
                                                                    </b-card-body>
                                                                </b-card>
                                                                <b-card
                                                                    v-if="row.row['YearsRecovered'].filter(a=> a.Error == null).length > 0"
                                                                    bg-variant="transparent"
                                                                    body-class="bg-transparent m-0 p-0"
                                                                    class="pb-0 w-100"
                                                                    header-class="bg-transparent m-0 p-0 pt-1">
                                                                    <template #header>
                                                                        <b-row class="m-0 p-0"
                                                                               @click.stop="activeErrors[row.row['PersistentRef']]['ask'] = !activeErrors[row.row['PersistentRef']]['ask']">
                                                                            <b-col class="m-0 p-0" cols="auto">
                                                                                <b-icon icon="dash-circle-dotted"
                                                                                        variant="dark"/>
                                                                            </b-col>
                                                                            <b-col class="text-dark m-0 ml-2 p-0">
                                                                                <u>{{
                                                                                        row.row['YearsRecovered'].filter(a => a.Error == null).length
                                                                                    }}
                                                                                    {{
                                                                                        $t('DatasAsk')[row.row['YearsRecovered'].filter(a => a.Error == null).length == 1 ? 0 : 1]
                                                                                    }}</u>
                                                                            </b-col>
                                                                            <b-col cols="auto">
                                                                                <b-button
                                                                                    v-if="activeErrors[row.row['PersistentRef']]['ask']"
                                                                                    class="bg-transparent border-0 text-dark px-0"
                                                                                    size="sm"
                                                                                    @click.stop="activeErrors[row.row['PersistentRef']]['ask'] = !activeErrors[row.row['PersistentRef']]['ask']">
                                                                                    <!-- Close -> "Fermer" -->
                                                                                    <b-icon v-b-tooltip.hover
                                                                                            :title="$t('Close')"
                                                                                            icon="chevron-up"
                                                                                            role="button"
                                                                                            scale="1.5"/>
                                                                                </b-button>
                                                                                <b-button v-else
                                                                                          class="bg-transparent border-0 text-dark px-0"
                                                                                          size="sm"
                                                                                          @click.stop="activeErrors[row.row['PersistentRef']]['ask'] = !activeErrors[row.row['PersistentRef']]['ask']">
                                                                                    <!-- Open -> "Ouvrir" -->
                                                                                    <b-icon v-b-tooltip.hover
                                                                                            :title="$t('Open')"
                                                                                            icon="chevron-down"
                                                                                            role="button"
                                                                                            scale="1.5"/>
                                                                                </b-button>
                                                                            </b-col>
                                                                        </b-row>
                                                                    </template>
                                                                    <b-card-body
                                                                        v-if="activeErrors[row.row['PersistentRef']]['ask']"
                                                                        class="mx-2 px-1 py-0 border border-dark border-right-0 border-top-0 border-bottom-0">
                                                                        <div>
                                                                            <div
                                                                                v-for="(error) in row.row['YearsRecovered'].filter(a => a.Error == null)">
                                                                                <b-icon v-b-tooltip.hover
                                                                                        :title="$t('AskData')"
                                                                                        icon="dash-circle-dotted"
                                                                                        variant="dark"/>
                                                                                <span class="font-weight-semibold ml-2">{{
                                                                                        error.Year == 'Ref' ? $t(error.Year) : error.Year
                                                                                    }}
                                                                                        | </span><small>{{
                                                                                    new Date(error.DateAsk).toLocaleDateString()
                                                                                }}</small>
                                                                            </div>
                                                                        </div>
                                                                    </b-card-body>
                                                                </b-card>
                                                            </template>
                                                            <template v-else>-</template>
                                                        </template>
                                                        <template #column(ConsumptionYears)="row">
                                                            <template v-if="row.row['ConsumptionYears'].length > 0">
                                                                <template
                                                                    v-for="(value, key) in row.row['ConsumptionYears']">
                                                                    <template v-if="key != 0">,</template>
                                                                    {{ $t(value) }}
                                                                </template>
                                                            </template>
                                                            <template v-else>-</template>
                                                        </template>
                                                    </GenericTable>
                                                </b-col>
                                            </b-row>
                                        </b-card-body>
                                        <template #footer>
                                            <b-row>
                                                <!-- Affiche le compteur d'éléments sélectionnés par l'utilisateur -->
                                                <b-col v-if="!loading"
                                                       align-self="center"
                                                       class="align-self-center font-weight-semibold">
                                                    {{
                                                        tableRows != undefined && tableRows.filter(a => a.Selected) != undefined
                                                        && tableRows.filter(a => a.Selected).length > 0 ?
                                                            tableRows.filter(a => a.Selected).length +
                                                            $t('SelectedRows')[tableRows.filter(a => a.Selected).length > 2 ?
                                                                2 : tableRows.filter(a => a.Selected).length] :
                                                            $t('SelectedRows')[0]
                                                    }}
                                                    ({{
                                                        tableRows != undefined && tableRows.filter(a => a.Selected) != undefined ?
                                                            tableRows.filter(a => a.Selected).length : 0
                                                    }}
                                                    {{ $t('On') }}
                                                    {{ tableRows != undefined ? tableRows.length : 0 }})
                                                </b-col>
                                                <b-col>
                                                    <div class="btn-circle"></div>
                                                </b-col>
                                            </b-row>
                                        </template>
                                    </b-card>
                                </pane>
                                <pane class="p-0 cols h-100" size="17">
                                    <b-card bg-variant="white"
                                            body-class="overflow-auto"
                                            class="p-0 m-0 w-100 h-100 d-flex flex-column headerHeight"
                                            footer-class="bg-white border border-bottom-0 border-left-0 border-right-0 py-2"
                                            header-class="bg-white border border-top-0 border-left-0 border-right-0 py-2">
                                        <template #header>
                                            <b-row class="m-0 p-0 w-100 mw-100">
                                                <b-col class="m-0 p-0 pt-2 font-weight-semibold">
                                                    <h5 :class="tableRows.filter(a=> a.Selected).length == 0 ? 'text-gray-dark' : ''">
                                                        {{ $t('Actions') }}
                                                    </h5>
                                                </b-col>
                                                <b-col class="m-0 p-0 justify-content-end" cols="auto">
                                                    <GenericButton :ButtonAction="ButtonsAction.Save"
                                                                   :Outline="false"
                                                                   :Tooltip="(userKeyChange ? $t('SaveUserKeyButton') : '') +
                                                            (userKeyChange && yearsToRecoverChange? ' & ': '') +
                                                            (yearsToRecoverChange ?  $t('Ask'): '')"
                                                                   :Type="ButtonsType.Icon"
                                                                   :VariantOverrideSave="Variant"
                                                                   :CurrentPage.sync="currentPage"
                                                                   :disabled="!userKeyChange && !yearsToRecoverChange"
                                                                   @click.stop.prevent="save"/>
                                                </b-col>
                                            </b-row>
                                        </template>
                                        <b-row class="m-0 p-0 d-flex h-100 mh-100">
                                            <b-col class="m-0 p-0">
                                                <b-row class="m-0 p-0 pb-3">
                                                    <b-col class="m-0 p-0 ">
                                                        <b-card
                                                            :class="tableRows.filter(a=> a.Selected).length == 0 ? 'text-gray-dark' : ''"
                                                            bg-variant="transparent"
                                                            class="p-0 m-0 w-100 h-100"
                                                            header-class="m-0 p-0 bg-transparent"
                                                            no-body>
                                                            <template #header>
                                                                <b-form-group class="mb-0">
                                                                    <b-form-checkbox v-model="userKeyChange"
                                                                                     :disabled="tableRows.filter(a=> a.Selected).length == 0"
                                                                                     :placeholder="$t('UserKeyChange')"
                                                                                     :value="true"
                                                                                     :variant="Variant"
                                                                                     class="checkVariant"
                                                                                     plain
                                                                                     size="lg">
                                                                        <h6 :class="tableRows.filter(a=> a.Selected).length == 0 ? 'text-gray-dark' : ''"
                                                                            class="font-weight-semibold p-0 py-1 h-100">
                                                                            {{ $t('UserKeyChange') }}
                                                                        </h6>
                                                                    </b-form-checkbox>
                                                                </b-form-group>
                                                            </template>
                                                            <div class="overflow-auto">
                                                                <b-form-group :label="$t('UserKey')"
                                                                              :label-class="!userKeyChange ? 'text-gray-dark' : ''"
                                                                              class="m-0 p-0 pb-2"
                                                                              content-cols="6"
                                                                              label-class="font-weight-semibold"
                                                                              label-cols="6"
                                                                              label-for="input-name">
                                                                    <b-form-input id="input-name" v-model="userKey"
                                                                                  :disabled="tableRows.filter(a=> a.Selected).length == 0 || !userKeyChange"
                                                                                  :placeholder="$t('UserKey')" trim/>
                                                                </b-form-group>
                                                                <div class="overflow-auto" v-html="$t('UserKeyInfo')"/>
                                                            </div>
                                                        </b-card>
                                                    </b-col>
                                                </b-row>
                                                <b-row
                                                    class="m-0 p-0 border border-left-0 border-bottom-0 border-right-0">
                                                    <b-col class="m-0 p-0 pt-3">
                                                        <b-card
                                                            :class="tableRows.filter(a=> a.Selected).length == 0 ? 'text-gray-dark' : ''"
                                                            bg-variant="transparent"
                                                            class="p-0 m-0 w-100 h-100 d-flex flex-column"
                                                            header-class="m-0 p-0 bg-transparent"
                                                            no-body>
                                                            <template #header>
                                                                <b-form-group>
                                                                    <b-form-checkbox v-model="yearsToRecoverChange"
                                                                                     :disabled="tableRows.filter(a=> a.Selected).length == 0"
                                                                                     :placeholder="$t('YearsToRecoverChange')"
                                                                                     :value="true"
                                                                                     :variant="Variant"
                                                                                     class="checkVariant" plain
                                                                                     size="lg">
                                                                        <h6 :class="tableRows.filter(a=> a.Selected).length == 0 ? 'text-gray-dark' : ''"
                                                                            class="font-weight-semibold p-0 py-1 h-100">
                                                                            {{ $t('YearsToRecoverChange') }}
                                                                        </h6>
                                                                    </b-form-checkbox>

                                                                </b-form-group>
                                                            </template>
                                                            <div>
                                                                <b-form-group :label="$t('YearsToRecover')"
                                                                              label-for="input-name">
                                                                    <b-form-checkbox-group v-model="yearsToRecover"
                                                                                           :disabled="tableRows.filter(a=> a.Selected).length == 0 || !yearsToRecoverChange"
                                                                                           :options="yearsToRecoverList"
                                                                                           :placeholder="$t('YearsToRecover')"
                                                                                           :variant="Variant"
                                                                                           class="pl-4 checkboxYears checkVariant"
                                                                                           plain
                                                                                           size="lg"
                                                                                           stacked
                                                                                           text-field="Value"
                                                                                           value-field="Id">
                                                                    </b-form-checkbox-group>
                                                                </b-form-group>
                                                                <span v-html="$t('YearsToRecoverInfo')"/>
                                                            </div>
                                                        </b-card>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                        </b-row>

                                        <template #footer>
                                            <div class="btn-circle"></div>
                                        </template>
                                    </b-card>
                                </pane>
                            </splitpanes>
                        </b-container>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>


<script lang="ts">

/** Traductions */
import locales from './locales/OperatParameter.json';

/** Imports généraux */
import {InjectReactive, Vue} from "vue-property-decorator";
import axios from "axios";
import {API_URL} from "@/App.settings";
import Component, {mixins} from 'vue-class-component';
import Dictionary from "@/types/Dictionary";
import {LinkUtils, ThemeUtils} from "@/components/commons/Utils";

/** Splitter */
import {Pane, Splitpanes} from 'splitpanes';
import 'splitpanes/dist/splitpanes.css'
/** Composants d'affichage du tableau */
import GenericTable, {
    CssClass,
    HeaderCustom,
    HeaderIcon,
    HeaderString,
    IconType,
    IHeader,
    Row
} from '@/components/commons/Generics/GenericTable.vue';

/** Composants d'affichage des boutons */
import GenericButton, {ButtonsAction, ButtonsType} from "@/components/commons/Generics/GenericButton.vue";

//#region Class

class OperatRow extends Row {
    private _persistentRef: string;
    private _invariant: string;
    private _parent: string;
    private _type: number;
    private _consumptionYears: string[];
    private _siret: string;
    private _siren: string;
    private _efa: string;
    private _userKey: string;
    private _yearsRecovered: { Year: string, DateAsk: Date, DateRequest: Date, Error: string }[];
    private _leftBound: number;

    constructor(persistentRef: string, name: string, data: Partial<OperatRow>) {
        super(persistentRef, name, data);
        this._persistentRef = persistentRef;
        this._invariant = data?.Invariant ?? "";
        this._parent = data?.Parent ?? "";
        this._type = data?.Type ?? -1;
        this._consumptionYears = data?.ConsumptionYears ?? [];
        this._siret = data?.SIRET ?? "";
        this._siren = data?.SIREN ?? "";
        this._efa = data?.EFA ?? "";
        this._userKey = data?.UserKey ?? "";
        this._yearsRecovered = data?.YearsRecovered ?? [];
        this._leftBound = data?.LeftBound ?? 0;
    }

    public get LeftBound(): number {
        return this._leftBound;
    }

    public set LeftBound(value: number) {
        this._leftBound = value;
    }

    public get YearsRecovered(): { Year: string; DateAsk: Date; DateRequest: Date; Error: string }[] {
        return this._yearsRecovered;
    }

    public set YearsRecovered(value: { Year: string; DateAsk: Date; DateRequest: Date; Error: string }[]) {
        this._yearsRecovered = value;
    }

    public get UserKey(): string {
        return this._userKey;
    }

    public set UserKey(value: string) {
        this._userKey = value;
    }

    public get EFA(): string {
        return this._efa;
    }

    public set EFA(value: string) {
        this._efa = value;
    }

    public get SIRET(): string {
        return this._siret;
    }

    public set SIRET(value: string) {
        this._siret = value;
    }

    public get SIREN(): string {
        return this._siren;
    }

    public set SIREN(value: string) {
        this._siren = value;
    }

    public get ConsumptionYears(): string[] {
        return this._consumptionYears;
    }

    public set ConsumptionYears(value: string[]) {
        this._consumptionYears = value;
    }

    public get Type(): number {
        return this._type;
    }

    public set Type(value: number) {
        this._type = value;
    }

    public get Parent(): string {
        return this._parent;
    }

    public set Parent(value: string) {
        this._parent = value;
    }

    public get Invariant(): string {
        return this._invariant;
    }

    public set Invariant(value: string) {
        this._invariant = value;
    }

    public get PersistentRef(): string {
        return this._persistentRef;
    }

    public set PersistentRef(value: string) {
        this._persistentRef = value;
    }
}

//#endregion Class

/** Composant  */
@Component({
    components: {
        GenericButton,
        Splitpanes,
        Pane,
        GenericTable
    },
    i18n: {messages: locales}
})
export default class OperatParameter extends mixins(Vue, ThemeUtils, LinkUtils) {
    // Déclaration des Enums Buttons
    public ButtonsType = ButtonsType;
    public ButtonsAction = ButtonsAction;

    @InjectReactive()
    private Variant!: string;

    /** Variables pour le tableau */
    private tableRows: OperatRow[] = [];
    private tableHeaders: IHeader[] = [];
    private loading: boolean = true;

    /** Variables pour l'affichage et la modification */
    private userKeyChange: boolean = false;
    private userKey: string = "";
    private yearsToRecoverChange: boolean = false;
    private yearsToRecover: string[] = [];
    private yearsToRecoverList: { Id: string, Value: string }[] = [];

    private activeErrors: Dictionary<{
        error: boolean,
        ok: boolean,
        ask: boolean
    }> = {};

    private currentPage: number = 1;

    /**
     * Chargement des listes
     * @private
     */
    private load() {
        this.loading = true;
        this.$store.dispatch("ShowLoadingMask", this.$t('Loading'));

        this.currentPage = 1;
        this.tableRows.splice(1, this.tableRows.length); // remise à vide de la table pour changement de taille pour le rechargement visuel

        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        axios.post(API_URL + "OperatParameter/Load", args).then((response) => {
            if (response && response.data) {
                console.debug("OperatParameter.vue - load - response.data", response.data);
                this.tableRows = [...response.data.Results].map(a => new OperatRow(a.PersistentRef, a.Name, {
                    Invariant: a.Invariant, Parent: a.Parent, Type: a.Type, ConsumptionYears: a.ConsumptionYears,
                    SIRET: a.SIRET, SIREN: a.SIREN, EFA: a.EFA, UserKey: a.UserKey, YearsRecovered: a.YearsRecovered,
                    LeftBound: a.LeftBound
                }));
                this.loading = false;

                this.activeErrors = Object.fromEntries(this.tableRows.map(a => ([a.PersistentRef, {
                    error: false,
                    ok: false,
                    ask: false
                }])));
            }
        }).catch(err => {
            console.error(err);
            this.$bvToast.toast(this.$t('AnErrorOccurred').toString(), {
                title: this.$t('Error').toString(),
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        }).finally(() => {
            this.$store.dispatch("HideLoadingMask", {});
        });
        this.loading = false;
    }

    /**
     * Enregistrement des valeur en base de données
     * @private
     */
    private save() {
        let selectedList = this.tableRows.filter(a => ('Selected' in a) && a.Selected == true).map(a => a.PersistentRef);

        /** Enregistrement de la clé sur les différents nœuds. */
        if (this.userKeyChange) {
            this.$store.dispatch("ShowLoadingMask", this.$t('SaveUserKey'));

            const args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            args["SelectedPersistentId"] = selectedList;
            args["UserKey"] = this.userKey;

            axios.post(API_URL + 'OperatParameter/UserKey/Save', args).then((response) => {
                this.userKeyChange = false;
                this.userKey = "";
                this.load();

                this.$bvToast.toast(this.$t('MsgSuccessfullSaveUserKey').toString(), {
                    title: this.$t('SaveUserKey').toString(),
                    autoHideDelay: 3000,
                    variant: "success",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            }).catch(err => {
                console.error(err);
                this.$store.dispatch("HideLoadingMask", {}).then(() => {
                    this.$bvToast.toast(this.$t('AnErrorOccurred').toString(), {
                        title: this.$t('SaveUserKey').toString(),
                        autoHideDelay: 10000,
                        variant: "danger",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                });
            }).finally(() => {
                this.$store.dispatch("HideLoadingMask", {});
            });
        }

        /** Demande de récupération des consommations des années indiquées. */
        if (this.yearsToRecoverChange && this.yearsToRecover.length > 0) {
            this.$store.dispatch("ShowLoadingMask", this.$t('SaveYearsToRecover'));

            const args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            args["SelectedPersistentId"] = selectedList;
            args["YearsToRecover"] = this.yearsToRecover;

            axios.post(API_URL + 'OperatParameter/YearsToRecover/Save', args).then((response) => {
                this.yearsToRecoverChange = false;
                this.yearsToRecover = [];
                this.loading = true;
                this.load();

                this.$bvToast.toast(this.$t('MsgSuccessfullSaveYearsToRecover').toString(), {
                    title: this.$t('SaveYearsToRecover').toString(),
                    autoHideDelay: 3000,
                    variant: "success",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
                this.loading = false;
            }).catch(err => {
                console.error(err);
                this.$store.dispatch("HideLoadingMask", {}).then(() => {
                    this.$bvToast.toast(this.$t('AnErrorOccurred').toString(), {
                        title: this.$t('SaveYearsToRecover').toString(),
                        autoHideDelay: 10000,
                        variant: "danger",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                });
            }).finally(() => {
                this.$store.dispatch("HideLoadingMask", {});
            });
        }
    }

    protected created() {
        this.tableHeaders = [
            new HeaderString('PersistentRef', this.$t('').toString(), {
                Sort: false,
                HideMenu: true,
                ShowColumn: false,
            }),
            new HeaderIcon('Type', this.$t('ObjectType').toString(), {
                CssClasses: [new CssClass({CssClass: 'text-center'})],
                ShowLabel: false,
                SortKey: 'LeftBound',
                IconType: IconType.Path
            }),
            new HeaderString('Invariant', this.$t('Invariant').toString(), {
                Sort: true,
                CssClasses: [new CssClass({CssClass: 'position-sticky'})]
            }),
            new HeaderString('Name', this.$t('Node').toString(), {Sort: true}),
            new HeaderString('Parent', this.$t('Parent').toString(), {Sort: true}),
            new HeaderCustom('ConsumptionYears', this.$t('ConsumptionYears').toString(), {Sort: true}),
            new HeaderString('SIRET', 'SIRET', {Sort: true}),
            new HeaderString('SIREN', 'SIREN', {Sort: true}),
            new HeaderString('EFA', this.$t('EFA').toString(), {Sort: true}),
            new HeaderString('UserKey', this.$t('UserKey').toString(), {Sort: true}),
            new HeaderCustom('YearsRecovered', this.$t('YearsRecovered').toString(), {Sort: true, Width: 200}),
            new HeaderCustom('LeftBound', this.$t('LeftBound').toString(), {
                Sort: false,
                Width: 200,
                ShowLabel: false,
                HideMenu: true,
                ShowColumn: false
            })
        ];

        this.loading = true;
    }

    mounted() {
        console.debug('OperatParameter.vue - mounted');
        this.$store.dispatch("ShowLoadingMask", this.$t('Loading'));

        this.yearsToRecoverList = [];
        this.yearsToRecoverList.push({Id: 'Ref', Value: this.$t('Ref').toString()});

        let now: number = new Date(Date.now()).getFullYear();
        for (let i = 2020; i <= now; i++) {
            this.yearsToRecoverList.push({Id: i.toString(), Value: i.toString()});
        }

        this.load();
        this.$store.dispatch("HideLoadingMask", {});
    }
}

</script>
<style scoped>

/** Variable --Variant injectée via generateVariantStyle(Variant) dans ObjectDisplaying (composant commun à toute la fiche objet) */
:deep(input[type=checkbox]:checked) {
    /** Change la couleur de la checkbox */
    accent-color: var(--Variant) !important;
}

:deep(input[type=radio]:checked) {
    /** Change la couleur du bouton radio */
    accent-color: var(--Variant) !important;
}

/** Pour que la page active prenne en compte la couleur de Variant */
:deep(.page-item.active .page-link) {
    background-color: var(--Variant) !important;
}

:deep(.page-link:hover) {
    background-color: var(--VariantLight) !important;
}

:deep(.splitpanes__splitter) {
    background-color: transparent !important;
    min-width: 16px !important;
    border: 0px;
}

</style>